import React from 'react'
import styled, {useTheme} from 'styled-components'

import {IconButton, Logo} from '@miro-site/core'

interface HeaderLogoProps {
  href: string
  color?: string
  className?: string
}

const HeaderLogoBase: React.FC<HeaderLogoProps> = ({href, className, ...restProps}) => {
  const theme = useTheme()
  const {color = theme.header.logo.color} = restProps

  return (
    <IconButton
      icon={
        <Logo
          $styles={{
            width: theme.header.logo.width,
            height: theme.header.logo.height,
            color: color,
            transition: 'color 250ms ease',
          }}
        />
      }
      label="Miro Logo"
      href={href}
      className={className}
      title="Go to the main page"
      {...restProps}
    />
  )
}

const HeaderLogo = styled(HeaderLogoBase)`
  ${({theme}) =>
    theme.normalizeStyles({
      width: theme.header.logo.width,
      height: theme.header.logo.height,
      position: 'relative',
      top: theme.header.logo.offset.top,
    })}
`

export default HeaderLogo
